var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav","v-on":_vm.check_browser()}},[_c('intro'),_c('company-info'),_c('main-slide'),_c('partnership')],1)}
var staticRenderFns = []

export { render, staticRenderFns }